import { useEffect } from 'react';

import { createNode, isHTMLElement } from '../../../../util';

const createLinkImage = (url: string): HTMLAnchorElement => {
  const img = createNode('img', {
    src: url,
    alt: '',
  });

  const a = createNode('a', {
    href: url,
    target: '_blank',
    rel: 'noopener noreferrer',
    tabIndex: 0,
  });

  a.appendChild(img);

  return a;
};

/**
 * Takes an html element and replaces all images with link to those images
 * opens in new tab
 */
export const useAttachImageClickHandlers = (element: HTMLElement | null) => {
  useEffect(() => {
    if (isHTMLElement(element)) {
      const images = element.querySelectorAll<HTMLImageElement>('img');

      images.forEach((img) => {
        const linkImg = createLinkImage(img.src);
        img.parentElement?.replaceChild(linkImg, img);
      });
    }
  }, [element]);
};
